/* @flow */

import { ContentType } from './base';
import {
  Text,
  LinkedItems,
  RichText,
  Asset,
  MultipleChoice,
  setAvailableContentTypes,
} from './elements';

export class PortalPromotionsCarousel extends ContentType {
  static typeName = 'portal_promotions_carousel';

  promotions: LinkedItems<PortalPromotion>;

  constructor(data: Object, modularData?: Object) {
    super(data, modularData);

    const { elements } = data;
    if (elements) {
      this.promotions = new LinkedItems(elements.promotions, modularData);
    }
  }
}

export class PortalPromotion extends ContentType {
  static typeName = 'portal_promotion';

  copy: RichText;
  backgroundImage: Asset;
  ctaLabel: Text;
  ctaLink: Text;

  tradingAccountIds: string[];
  contentTheme: MultipleChoice;

  constructor(data: Object, modularData?: Object) {
    super(data, modularData);

    const { elements } = data;
    if (elements) {
      this.copy = new RichText(elements.copy);
      this.backgroundImage = new Asset(elements.background_image);
      this.ctaLabel = new Text(elements.cta_label);
      this.ctaLink = new Text(elements.cta_link);

      if (elements.trading_account_ids && typeof elements.trading_account_ids.value === 'string') {
        this.tradingAccountIds = elements.trading_account_ids.value.split(' ').filter(id => !!id);
      } else {
        this.tradingAccountIds = [];
      }
      this.contentTheme = new MultipleChoice(elements.content_theme);
    }
  }
}

export class GlobalMessageBanner extends ContentType {
  static typeName = 'myer_global_message';

  globalMessage: RichText;

  constructor(data: Object, modularData?: Object) {
    super(data, modularData);

    const { elements } = data;
    if (elements) {
      this.globalMessage = new RichText(elements.message);
    }
  }
}

setAvailableContentTypes([PortalPromotionsCarousel, PortalPromotion, GlobalMessageBanner]);
